import script from "./SingleCellList.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleCellList.vue?vue&type=script&setup=true&lang=js"

import "./SingleCellList.vue?vue&type=style&index=0&id=af9b2ce6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9b2ce6"]])

export default __exports__